<style>
  .chart-row,
  .chart-col {
    display: flex;
    gap: 1em;
  }

  .chart-row {
    flex-direction: row;
  }

  .chart-col {
    flex-direction: column;
  }

  .chart-pill,
  .chart-rect {
    padding: 5px;
    text-align: center;
    border: 2px solid #999;
  }

  .chart-pill {
    flex: 1;
    border-radius: 1em;
    border-style: dashed;
  }

  .chart-rect {
    flex: 0;
    margin: auto 0;
    background: #eee;
    cursor: default;
  }

  .chart-line-h {
    height: 2px;
    min-width: 3em;
    background: #999;
    margin: auto -1em;
  }


  .SpanCome {
    color: #2291f1;
    font-weight: bold;
    cursor: pointer;
  }

  .SpanOut {
    color: #f16722;
    font-weight: bold;
    cursor: pointer;
  }
</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Customer Instrument Status</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Customer Name </label>
          <input type="text" class="form-control" name="Customer_Filter_List" [(ngModel)]="Customer_Filter_List"
            placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button"
            (click)="ReadData_Certificate(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="row">

        <ng-container *ngFor="let item of DataList_Certificate| paginate
        : {
            id: 'DataList_UserTable',
            itemsPerPage: 20,
            currentPage: page,
            totalItems: DataList_Certificate.length
          }">

          <div class="form-group col-md-12">
            <div style="width: 100%; margin-top: 25px;">
              <div class="chart-row">
                <div class="chart-pill chart-col">
                  <div class="chart-rect">
                    <span>{{item.customer}}</span>
                    <br />
                    <span title="Letter Count" (click)="openModalRef_Letter(templateLetter,item.letter)" class="SpanCome">{{item.letter.length}}</span>
                  </div>
                </div>
                <div class="chart-line-h"></div>
                <div class="chart-pill chart-col">
                  <div class="chart-rect" style="background: white;">
                    <div class="tree">
                      <div class="chart-row">
                        <div class="chart-pill chart-col" style="border: 0px;">
                          <div class="chart-rect">
                            <span>Reception</span>
                            <br />
                            <span title="Letter Instruments" class="SpanCome">{{item.total_outlocation_device}}</span>
                            /
                            <span (click)="openModalRef_Calibration(templateCalibration,item.calibration_outlocation_device)" title="Received Instruments"
                              class="SpanOut">{{item.calibration_outlocation_device.length}}</span>
                          </div>
                        </div>

                        <div class="chart-line-h"></div>
                        <div class="chart-pill chart-col" style="border: 0px;">
                          <div class="chart-rect">
                            <span>Check-in</span>
                            <br />
                            <span (click)="openModalRef_Calibration(templateCalibration,item.calibration_download_outlocation_device)" title="Check-in Completed"
                              class="SpanCome">{{item.calibration_download_outlocation_device.length}}</span>
                            /
                            <span (click)="openModalRef_Calibration(templateCalibration,item.calibration_download_outlocation_device_not)" title="Awaiting Check-in"
                              class="SpanOut">{{item.calibration_download_outlocation_device_not.length}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="chart-rect">
                    <span>On-site Work</span>
                    <br />
                    <span title="Letter Instruments" class="SpanCome">{{item.total_inlocation_device}}</span>
                    /
                    <span title="Received Instruments" (click)="openModalRef_Calibration(templateCalibration,item.calibration_inlocation_device)"
                      class="SpanOut">{{item.calibration_inlocation_device.length}}</span>
                  </div>
                </div>

                <div class="chart-line-h"></div>
                <div class="chart-pill chart-col">
                  <div class="chart-rect" style="background: white;">
                    <div class="tree">
                      <div class="chart-row">
                        <div class="chart-pill chart-col" style="border: 0px;">
                          <div class="chart-rect">

                            <span>Work Completion</span>
                            <br />
                            <span title="Work Completed" (click)="openModalRef_Calibration(templateCalibration,item.calibration_done_outlocation_device)"
                              class="SpanCome">{{item.calibration_done_outlocation_device.length}}</span>
                            /
                            <span title="Awaiting Work" (click)="openModalRef_Calibration(templateCalibration,item.calibration_done_outlocation_device_not)"
                              class="SpanOut">{{item.calibration_done_outlocation_device_not.length}}</span>
                          </div>
                        </div>

                        <div class="chart-line-h"></div>
                        <div class="chart-pill chart-col" style="border: 0px;">
                          <div class="chart-rect">
                            <span>Certificate Registration</span>
                            <br />
                            <span title="Certificate Registered" (click)="openModalRef_Calibration(templateCalibration,item.calibration_certificate_outlocation_device)"
                              class="SpanCome">{{item.calibration_certificate_outlocation_device.length}}</span>
                            /
                            <span title="Awaiting Certificate Registration" (click)="openModalRef_Calibration(templateCalibration,item.calibration_certificate_outlocation_device_not)"
                              class="SpanOut">{{item.calibration_certificate_outlocation_device_not.length}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="chart-rect">
                    <span>Certificate Registration</span>
                    <br />
                    <span title="Certificate Registered" (click)="openModalRef_Calibration(templateCalibration,item.calibration_certificate_inlocation_device)"
                      class="SpanCome">{{item.calibration_certificate_inlocation_device.length}}</span>
                    /
                    <span title="Awaiting Certificate Registration" (click)="openModalRef_Calibration(templateCalibration,item.calibration_certificate_inlocation_device_not)"
                      class="SpanOut">{{item.calibration_certificate_inlocation_device_not.length}}</span>
                  </div>
                </div>

                <div class="chart-line-h"></div>
                <div class="chart-pill chart-col">
                  <div class="chart-rect" style="background: white;">
                    <div class="tree">
                      <div class="chart-row">
                        <div class="chart-pill chart-col" style="border: 0px;">
                          <div class="chart-rect">
                            <span>Certificate Review</span>
                            <br />
                            <span title="Certificate Reviewed" (click)="openModalRef_Calibration(templateCalibration,item.calibration_controll_outlocation_device)"
                              class="SpanCome">{{item.calibration_controll_outlocation_device.length}}</span>
                            /
                            <span title="Awaiting Certificate Review" (click)="openModalRef_Calibration(templateCalibration,item.calibration_controll_outlocation_device_not)"
                              class="SpanOut">{{item.calibration_controll_outlocation_device_not.length}}</span>
                          </div>
                        </div>

                        <div class="chart-line-h"></div>
                        <div class="chart-pill chart-col" style="border: 0px;">
                          <div class="chart-rect">
                            <span>Check-out</span>
                            <br />
                            <span title="Check-out Completed" (click)="openModalRef_Calibration(templateCalibration,item.calibration_upload_outlocation_device)"
                              class="SpanCome">{{item.calibration_upload_outlocation_device.length}}</span>
                            /
                            <span title="Awaiting Check-out" (click)="openModalRef_Calibration(templateCalibration,item.calibration_upload_outlocation_device_not)"
                              class="SpanOut">{{item.calibration_upload_outlocation_device_not.length}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="chart-rect">
                    <span>Certificate Review</span>
                    <br />
                    <span title="Certificate Reviewed" (click)="openModalRef_Calibration(templateCalibration,item.calibration_controll_inlocation_device)"
                      class="SpanCome">{{item.calibration_controll_inlocation_device.length}}</span>
                    /
                    <span title="Awaiting Certificate Review" (click)="openModalRef_Calibration(templateCalibration,item.calibration_controll_inlocation_device_not)"
                      class="SpanOut">{{item.calibration_controll_inlocation_device_not.length}}</span>

                  </div>
                </div>

                <div class="chart-line-h"></div>
                <div class="chart-pill chart-col">
                  <div class="chart-rect">
                    <span>Invoice Count</span>
                    <br />
                    <span title="Issued Invoice Count" class="SpanCome">{{item.factor}}</span>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </ng-container>


        <pagination-controls
        id="DataList_UserTable"
        nextLabel="Next"
        previousLabel="Previous"
        (pageChange)="page = $event"
      ></pagination-controls>

      </div>
    </div>

  </div>

</div>



<ng-template #templateLetter>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> Letter Count </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Letter.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Letter Number</th>
            <th>Laboratory Instruments</th>
            <th>Site Instruments</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of LetterModalList">
           <td>{{LetterModalList.indexOf(item)+1}}</td>
            <td>{{item['letter_code']}}</td>
            <td (click)="exportexcel_Letter(item['device_outlocation_total'])">
              {{item['device_outlocation_total'].length}} rows
              <br/>
              <i  class="fa  fa-eye"></i>
            </td>
            <td (click)="exportexcel_Letter(item['device_inlocation_total'])">
              {{item['device_inlocation_total'].length}} rows 
              <br/>
              <i  class="fa  fa-eye"></i>
            </td>
          </tr>
        </tbody>
      </table>

      <br/>

      <table *ngIf="LetterModalList_letter.length>0" class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #39419b; color: white;">
          <tr>
            <th>#</th>
            <th>Name Equipment</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of LetterModalList_letter| paginate
          : {
              id: 'DataList_FeildTable',
              itemsPerPage: 10,
              currentPage: pageLetter,
              totalItems: LetterModalList_letter.length
            }">
            <td>{{LetterModalList_letter.indexOf(item)+1}}</td>
            <td>{{item['device_name']}}</td>
            <td>{{item['tedad']}}</td>
           </tr>
        </tbody>
      </table>
      <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
      </pagination-controls>

   </div>
  </div>
  <div class="modal-footer">
     <button type="button" class="btn btn-danger" (click)="modalRef_Letter.hide()">Close</button>
  </div>
</ng-template>


<ng-template #templateCalibration>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> Equipment List </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Calibration.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Name Equipment</th>
            <th>Equipment Code</th>
            <th>Equipment Serial Number</th>
            <th>Reception Description</th>
            <th>Location</th>
            <th>Certificate Code</th>
            <th>Calibration Certificate File</th>
          </tr>
        </thead>
        <tbody *ngIf="CalibrationModalList.length>0">
          <tr *ngFor="let item of CalibrationModalList">
           <td>{{CalibrationModalList.indexOf(item)+1}}</td>
           <td>{{item['device_device_name']}}</td>
            <td>{{item['device_code']}}</td>
            <td>{{item['device_serail']}}</td>
            <td>{{item['receptionDsc']}}</td>
            <td>{{item['asteghrar']}}</td>
            <td>{{item['certificateCode']}}</td>
            <td>
              <a *ngIf="item['filename']"  target="_blank" href="{{BaseUrl}}File/Calibration/{{item['filename']}}" class="btn btn-info"><i class="fa fa-eye"></i> Calibration Certificate File </a>
              <a  *ngIf="item['certificate'] && !item['filename']" target="_blank" href="{{BaseUrl}}{{item['certificate']}}" class="btn btn-info"><i class="fa fa-eye"></i> Calibration Certificate File </a>
            </td>
          </tr>
        </tbody>
      </table>

   </div>
  </div>
  <div class="modal-footer">
     <button type="button" class="btn btn-danger" (click)="modalRef_Calibration.hide()">Close</button>
  </div>
</ng-template>
